import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';

type TableActionPermissions = {
  canEdit: boolean;
  canDelete: boolean;
};
const tableActions:
  (onDelete: () => void, onFormOpen: () => void) =>
    (arg0: TableActionPermissions) => React.ReactElement[] =
  (onDelete, onFormOpen) =>
    ({ canEdit, canDelete }) => {
      const arr: React.ReactElement[] = [];
      if (canEdit) {
        arr.push(
          <GridActionsCellItem
            icon={<DriveFileRenameOutlineIcon />}
            label="Edit"
            onClick={onFormOpen}
          />,
        );
      }
      if (canDelete) {
        arr.push(<GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={onDelete}
        />);
      }
      return arr;
    };

export default tableActions;
